import styled from 'styled-components'

const CheckboxInputUi = styled.input``

export default CheckboxInputUi
